import { newsSlugs, vacanciesSlugs } from '@boss/constants/corporate-jobs';
import { NavigationItemFields, QuickLinksFields } from '@boss/types/corporate-jobs';

const getHref = (link: NavigationItemFields, locale: string): string | undefined => {
  if (link.internalPageLink && link.internalPageLink.__typename === 'contentPage') {
    return link.internalPageLink.slug;
  }
  if (link.internalPageLink && link.internalPageLink.__typename === 'overviewPage') {
    if (link.internalPageLink.type === 'latest-news') {
      return newsSlugs[locale];
    }
    if (link.internalPageLink.type === 'vacancies') {
      return vacanciesSlugs[locale];
    }
  }
  if (link.externalLink) {
    return link.externalLink;
  }

  return undefined;
};

const getQuickLinkProps = (
  entry: QuickLinksFields,
  locale: string,
  hasBackground?: boolean,
): {
  title: string;
  links: {
    label?: string;
    id: string;
    href?: string;
  }[];
  textClassName?: string;
} => ({
  title: entry.title,
  links: entry.links.map(link => {
    return {
      label: link.label ?? undefined,
      href: getHref(link, locale),
      id: link.id,
    };
  }),
  textClassName: hasBackground ? 'text-white' : '',
});

export default getQuickLinkProps;
